import type { Metric } from '@atlassian/browser-metrics/metric';

import { createConcurrentCustomMetric } from '../../metricConfigs.ts';
import { TIME_TO_APP_IDLE_KEY } from '../../metric-keys/index.ts';

export const TIME_TO_APP_IDLE_METRIC: (concurrentId: string | number) => Metric =
	createConcurrentCustomMetric({
		key: TIME_TO_APP_IDLE_KEY,
	});
